import {Injectable} from '@angular/core';

@Injectable()
export class StatisticService {

  constructor() { }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/statistic/statistic.service.ts